import { Component, ViewChild } from '@angular/core';

import {AlertController, App, NavController, Platform, ToastController} from 'ionic-angular';
import { AngularFireDatabase, AngularFireList } from 'angularfire2/database';
import { UserData } from '../../../providers/user-data';
import {UiData} from "../../../providers/ui-data";
import {FormGroup, FormBuilder, FormControl, Validators} from '@angular/forms';
import {HomePage} from "../../home/home";
import { DatePickerModule } from 'ion-datepicker';
import { DatePickerDirective } from 'ion-datepicker';
import * as moment from 'moment';
import * as _ from "lodash";


@Component({
  selector: 'page-civility',
  templateUrl: 'civility.html'
})
export class CivilityPage {
  username: string;
  countryList: any;
  civilityRef: any;
  civilityData: any;
  civilityForm : FormGroup;
  submitAttempt: boolean = false;
  modified: boolean = true;
  browserMode: boolean = false;
  maxBirthDate: Date;

  @ViewChild(DatePickerDirective) private datepickerDirective:DatePickerDirective;

  constructor(
      public alertCtrl: AlertController,
      public nav: NavController,
      public userData: UserData,
      public uiData: UiData,
      public afDatabase: AngularFireDatabase,
      private formBuilder: FormBuilder,
      public app: App,
      public toastCtrl: ToastController,
      public platform: Platform
  ) {
    //userData.setToken('nova4');
      this.civilityForm = this.formBuilder.group({
          civility: [null, Validators.required],
          nom: ['', [Validators.required,Validators.minLength(2)]],
          prenom: ['', [Validators.required,Validators.minLength(2)]],
          birthday: ['', [Validators.required]],
          email: ['', [Validators.required, Validators.email]],
          phone: ['', [Validators.required, Validators.pattern(/^(?:0|\(?\+33\)?\s?|0033\s?)[1-79](?:[\.\-\s]?\d\d){4}$/)]],

      });
      this.maxBirthDate = new Date();
      this.browserMode = this.uiData.isBrowser();
  }
    back(event)
    {

        try{
            this.app.getRootNav().setRoot(HomePage);
            this.app.getRootNav().popToRoot();
        }catch(e){}
    }
  change()
  {
      this.modified=true;
  }
  ngAfterViewInit() {
    this.civilityData = {
            civility : 'mme',
            nom : '',
            prenom : '',
            birthday : '',
            email : '',
            phone : ''
        }
    ;
    this.countryList = this.uiData.countryList();
    var that = this;
    this.userData.load().subscribe(data => {
      if(!data.civility)
      {
          that.userData.set('civility',that.civilityData);
      }
      that.civilityData = that.userData.get('civility');
    });
    /*this.userData.getToken().then(function(token){
        that.civilityRef = that.afDatabase.object('/users/'+token+'/civility');
        that.civilityRef.valueChanges().subscribe(data => {
            if(!data)
            {
                that.civilityRef.set(that.civilityData);
            }
            that.civilityData = data;
        });
    });*/
     /* this.userData.getUserDbReference('civility').valueChanges().subscribe(data => {
          if(!data)
          {
              that.userData.getUserDbReference('civility').set(that.civilityData);
          }
          that.civilityData = data;
      });*/

  }
  savecivility() {

      this.submitAttempt=true;
      var that = this;

      if(this.civilityForm.valid)
      {
          let prompt = this.alertCtrl.create({
              title: 'Confirmation des informations',
              message: that.uiData.getDataValidationWarning(),
              buttons: [
                  {
                      text: 'Oui',
                      handler: data => {
                          that.userData.set('civility',that.civilityData);
                          //that.app.getRootNav().setRoot('HomePage');
                          that.toastSuccess('Vos informations ont été enregistrées.');
                      }
                  },
                  {
                      text: 'Annuler',
                      handler: data => {

                      }
                  }
              ]
          });
          prompt.present();
      }
      else
      {
          //console.log(this.civilityForm.value);
      }

  }
    toastSuccess(message: string)
    {
        let toast = this.toastCtrl.create({
            showCloseButton: true,
            cssClass: 'profile-bg',
            message: message,
            duration: 2000,
            position: 'bottom',
            closeButtonText:'Ok'
        });
        toast.present();
    }
    swipe(event)
    {
        if(event.direction === 2) {
            this.nav.parent.select(1);
        }
        /*if(event.direction === 4) {
            this.nav.parent.select(0);
        }*/
    }
    datePick(e){
      var m = moment(e);
      this.civilityData.birthday = m.format('YYYY-MM-DD');
    }
    dateFocus(){
        this.datepickerDirective._click(null);
        //console.log('focus');
    }
    birthdayDate(){
      if(this.civilityData.birthday)
      {
          return new Date(this.civilityData.birthday);
      }
      else
      {
          return new Date();
      }

    }
}



// WEBPACK FOOTER //
// ./src/pages/account/civility/civility.ts